import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import { URLGIFTING, URLGIFTINGUPSELLDEALS } from '../config/setup/setup';
import httpCommonHeaders from '../helpers/httpCommonHeaders';

export const getGift = async (giftData) => {
  const { data } = await axios({
    cache: false,
    data: { gift: giftData },
    headers: httpCommonHeaders(),
    method: 'POST',
    url: URLGIFTING,
    withCredentials: true,
  });

  return data;
};

/**
 * Fetch gifting upsell deals from backend API.
 * This endpoint returns the same deals for all users (no authentication required).
 *
 * BE Endpoint: GET /v1/gift-upsell-deals
 *
 * @returns {Promise<{giftingUpsellDeals: Array}>} Promise resolving to gifting upsell deals
 *
 * @example
 * const { giftingUpsellDeals } = await getGiftingUpsellDeals();
 * // Returns: { giftingUpsellDeals: [{ dealId, title, imgUrl, products: [...] }] }
 */
export const getGiftingUpsellDeals = async () => {
  try {
    const response = await axios({
      headers: httpCommonHeaders(),
      method: 'GET',
      url: URLGIFTINGUPSELLDEALS,
      validateStatus: (status) => status < 500,
    });

    return response?.data;
  } catch (error) {
    console.warn('Failed to fetch gifting upsell deals:', error);

    return { giftingUpsellDeals: [] };
  }
};
